// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"a15c6dd0","480":"f4ae2eda","972":"8ed8a4e8"}[chunkId] + ".chunk.js";
};